module.exports = __webpack_public_path__ + "static/pool-c-4e05191a46505b2ff2be34518284dc52.svg";